import { rem } from 'polished'
import styled from 'styled-components'

import { mediaQueryUp } from 'components/utils/breakpoint'

const ImageArea = styled.div`
  display: none;

  ${mediaQueryUp.tablet} {
    display: initial;
    width: ${rem(104)};
  }
`

const ContentArea = styled.div`
  flex: 1;
`

const _DetailCardLayout = styled.div`
  background-color: ${(props) => props.theme.palette.neutral.default.eight};
  padding: ${rem(20)};
  break-inside: avoid-page;
  display: flex;

  ${mediaQueryUp.tablet} {
    padding: ${rem(20)} ${rem(40)};
    gap: ${rem(20)};
  }
`

const DetailCardLayout = _DetailCardLayout as typeof _DetailCardLayout & {
  Image: typeof ImageArea
  Content: typeof ContentArea
}

DetailCardLayout.Image = ImageArea
DetailCardLayout.Content = ContentArea

export default DetailCardLayout
